/* eslint-disable no-console */
import { GenericAnalyticsDestination } from '../types';

class DebugDestination
    implements GenericAnalyticsDestination<'debug', undefined>
{
    public name: 'debug';
    public raw: undefined;
    private isInitialized: boolean;
    static logPrefix = 'Analytics Debug';

    constructor() {
        this.name = 'debug';
        this.isInitialized = false;
    }

    private getPrefix() {
        return `${DebugDestination.logPrefix}:${
            this.isInitialized ? '' : ' [Untracked] '
        }`;
    }

    public async init(...props: any[]) {
        this.isInitialized = true;
        console.info(
            `${DebugDestination.logPrefix} init (flushes all [Untracked] events)`,
            {
                props,
            }
        );
    }

    public async track(event: string, properties?: Record<string, any>) {
        console.info(`${this.getPrefix()} track`, {
            event,
            properties,
        });
    }

    public async flush() {
        console.info(`${this.getPrefix()} flush`);
    }

    public reset() {
        console.info(`${this.getPrefix()} reset`);
    }

    public async identify(uuid: string) {
        console.info(`${this.getPrefix()} identify`, { uuid });
    }

    public async setUserProperties(props: Record<string, any>) {
        console.info(`${this.getPrefix()} setUserProperties`, {
            props,
        });
    }

    public async register(props: Record<string, any>) {
        console.info(`${this.getPrefix()} register`, {
            props,
        });
    }

    public isLoaded() {
        return true;
    }
}

export function createDebugDestination(): DebugDestination {
    return new DebugDestination();
}
